import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import getStoriesByCollection from "../../../utils";
import { CollectionName } from "../../atoms/collection-name";
import OnecolFourStories from "../../molecules/one-col-four-stories";
import SubscribeOnlyColumn from "../../molecules/subscribe-only-column";

import { Link } from "@quintype/components";
import "./three-collections-with-poll.m.css";

const ThreeCollectionsWithPoll = ({ collection = {} }) => {
  const [isHindi, setIsHindi] = useState(false);

  useEffect(() => {
    const isHindiCheck = !!(
      global.location && global.location.host.includes("hindi")
    );
console.log("hindi story")
    setIsHindi(isHindiCheck);
  }, []);
  if (collection.items.length <= 0) {
    return null;
  }
  const collections = collection.items.filter(
    collection => collection.type === "collection"
  );
  const firstCollectionStories = getStoriesByCollection(collections[0]) || [];
  const secondCollectionStories = getStoriesByCollection(collections[1]) || [];
  const thirdCollectionStories = getStoriesByCollection(collections[2]) || [];
  return (
    <div className="full-width-with-padding" styleName="wrapper">
      <div styleName="grid-container" className="container">
        {firstCollectionStories.length > 0 && (
          <div styleName="col">
            <CollectionName collection={collections[0]} />
            <SubscribeOnlyColumn stories={firstCollectionStories} />
          </div>
        )}
        {secondCollectionStories.length > 0 && (
          <div styleName="col">
            <CollectionName collection={collections[1]} />
            <OnecolFourStories stories={secondCollectionStories} />
          </div>
        )}

        {thirdCollectionStories.length > 0 && (
          <div styleName="col">
            <CollectionName collection={collections[2]} />
            <OnecolFourStories stories={thirdCollectionStories} />
          </div>
        )}
        {false?
        (<div styleName="img-wrapper">
          <Link href={`/hindi-whatsapp-optin`}>
            <img
              styleName="banner"
              src="https://images.assettype.com/newslaundry/2023-06/b4adfa8d-db04-4bb2-a0bd-7884b8d88bea/Untitled_design__14_.png"
            />
          </Link>
        </div>):
        (<div styleName="img-wrapper">
          <Link href={`/download-app?ref=vertical-offer`}>
            <img
              styleName="banner"
              src="https://images.assettype.com/newslaundry/2022-05/b80947fb-36c4-434d-afac-a5d6bfc63b72/vertical_banner_new.jpg"
            />
          </Link>
        </div>)}
      </div>
    </div>
  );
};

ThreeCollectionsWithPoll.propTypes = {
  collection: PropTypes.object
};

export default ThreeCollectionsWithPoll;

ThreeCollectionsWithPoll.storyLimit = 3;
